import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.auth.login');
import { OnInit, Output, EventEmitter, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-auth-login',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.auth.login/view.scss */
:host {
  display: block;
}`],
})
export class ComponentAuthLoginComponent implements OnInit {
    @Output() public changeMode = new EventEmitter<string>();

    public data: any = { id: '', password: '' };
    public showPassword: boolean = false;
    public isLoading: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        await this.service.render();
    }

    public async login() {
        if (!this.data.id || !this.data.password) {
            await this.service.alert.show({ message: '아이디와 비밀번호를 입력해주세요.', status: 'error', action: '확인' });
            return;
        }

        this.isLoading = true;
        this.ref.detectChanges();

        const user = { ...this.data };
        user.password = this.service.auth.hash(user.password);

        try {
            const { code, data } = await wiz.call('login', user);
            if (code === 200) {
                this.service.href('/main');
                return;
            }
            this.isLoading = false;
            this.ref.detectChanges();
            await this.service.alert.show({
                message: data || '로그인에 실패했습니다.',
                status: 'error',
                action: '확인'
            });
        } catch (e) {
            this.isLoading = false;
            this.ref.detectChanges();
            await this.service.alert.show({
                message: '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
                status: 'error',
                action: '확인'
            });
        }
    }

    public gotoRegister() {
        this.changeMode.emit('register');
    }

    public gotoForgot() {
        this.changeMode.emit('forgot');
    }
}

export default ComponentAuthLoginComponent;